export const EVENT_INVALIDATION_MAP: Record<string, string[]> = {
  "review.created": ["page", "media-review", "page", "content-workbench"],
  "review.decision.updated": ["page", "media-review"],
  "review.completed": ["page", "media-review"],
  "listing.intake.updated": ["page", "listing-intake"],
  "listing.refine.updated": ["page", "listing-intake", "page", "image-builder", "page", "content-workbench", "assets", "listing-images", "listing", ""],
  "listing.release.updated": ["final-approval-queue", "", "final-approval-detail", "", "listing", "", "page", "content-workbench"],
  "listing.media.approved": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", ""],
  "listing.media.processed": ["final-approval-queue", "", "final-approval-detail", "", "listing", "", "assets", "listing-images"],
  "slideshow.render.completed": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", ""],
  "slideshow.output.completed": ["final-approval-queue", "", "final-approval-detail", "", "slideshow", ""],
  "listing.published": [
    "page",
    "final-listing-approval",
    "dashboard",
    "command-center",
  ],
  "deal.updated": ["page", "dealz-control", "page", "livedealz-intake"],
  "deal.status.changed": ["page", "dealz-control"],
  "campaign.status.changed": ["page", "campaigns"],
  "supplier.status.changed": ["page", "suppliers-providers"],
  "user.updated": ["page", "roles-permissions"],
  "access-request.decided": ["page", "roles-permissions", "page", "inbox"],
  "content.version.created": ["page", "content-workbench", "listing", ""],
  "content.approved": ["page", "content-workbench", "listing", "", "final-approval-queue", "", "final-approval-detail", ""],
  "automation.job.queued": ["page", "automation"],
  "automation.job.completed": ["page", "automation"],
  "automation.job.failed": ["page", "automation"],
  "work_item.assigned": ["operations", "work-items", "page", "inbox"],
  "inbox.item.created": ["page", "inbox", "dashboard", "app-shell"],
  "platform.setting.updated": ["page", "platform-settings"],
  "platform.settings.changed": ["page", "platform-settings"],
  "asset.created": ["page", "user-asset-libraries"],
  "media_project.completed": [
    "page",
    "image-builder",
    "page",
    "video-slideshow-builder",
  ],
};
